import React from 'react';
import { TimelineLite } from 'gsap/TimelineLite';
import ReactPlayer from 'react-player';

class PageLoader extends React.Component {

	animateOut() {
		let tl = new TimelineLite();
		tl.to(this.inner, 0.2, {opacity: 0});
		tl.to(this.underlay1, 0.6, {y: '100%'});
		tl.to(this.underlay2, 0.6, {y: '-100%'}, '-=0.55');
		tl.to(this.underlay3, 0.6, {y: '100%'}, '-=0.55');
		tl.to(this.underlay4, 0.6, {y: '-100%'}, '-=0.55');
		tl.set(this.container, {display: 'none'});
	}

	render() {
		return (
			<div className="page-loader" ref={el => this.container = el}>
				<div className="inner" ref={el => this.inner = el}>
					<ReactPlayer url="/video/jw-loader2.mp4" width="100%" height="100%" onEnded={this.animateOut.bind(this)} playing={true} muted={true} playsinline={true} />
				</div>
				<div className="underlay">
					<div ref={el => this.underlay1 = el} />
					<div ref={el => this.underlay2 = el} />
					<div ref={el => this.underlay3 = el} />
					<div ref={el => this.underlay4 = el} />
				</div>
			</div>
		);
	}

}

export default PageLoader;


// WEBPACK FOOTER //
// ./src/js/components/PageLoader.js